import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "../modules/Auth/login";
import NPAProperties from "../modules/NPAProperties";

import CommonLayout from "../layouts";
import { AuthProvider } from "../context/AuthContext";
import { LoaderProvider } from "../context/LoaderContext";
import Loader from "../components/loader";
import PrivateRouteLayout from "./PrivateRouteLayout";
import { routes } from "./pageRoutes";
import AddNpaProperties from "../modules/NPAProperties/AddNpaProperties";
import NPAInquiries from "../modules/NPAInquiries";
import ViewNpaProperties from "../modules/NPAProperties/ViewNpaProperties";
import BankUsers from "../modules/BankManage/BankUsers/index";
import AllUser from "../modules/Users/AllUsers/index";
import RequestVerification from "../modules/Users/VerifyRequest/index";
import Plans from "../modules/Subscription/Plans/index";
import CreateEditPlan from "../modules/Subscription/Plans/CreateEditPlan";
import Subscriptions from "../modules/Subscription/Subscriptions/index";
import SubscriptionDetails from "../modules/Subscription/SubscriptionDetails/index";
import PaymentList from "../modules/Subscription/Payment/index";
import OtpMessage from "../modules/Otp/index";
import Banners from "../modules/Banner/Banners/index";
import AddBanner from "../modules/Banner/Banners/AddBanner";
import Profile from "../modules/Profile";
import Banks from "../modules/BankManage/Banks";
import ViewBankDetails from "../modules/BankManage/Banks/ViewBankDetails";
import JantriModule from "../modules/Jantri/index";
import Setting from "../modules/Setting/index";
import MapModule from "../modules/Map/index";
import GeoreferenceWorkspace from "../modules/Map/GeoreferenceWorkspace";
import MapGeoreferenceModule from "../modules/MapGeoreference/index";
import ImportPackage from "../modules/MapGeoreference/ImportPackage";
import CompanyDetails from "../modules/Company/details/CompanyDetails";
import PortfolioForm from "../modules/Company/details/PortfolioForm";
import IntroductionScreens from "../modules/IntroductionScreens";
import AddIntroductionScreen from "../modules/IntroductionScreens/AddIntroductionScreen";
import ProfileSuggestionCards from "../modules/ProfileSuggestionCards";
import Features from "../modules/Subscription/Features/index";
import GisTrial from "../modules/Subscription/GisTrial";
import Feedback from "../modules/Feedback";
import MarketplaceList from "../modules/MarketPlace/MarketplaceList";
import MarketplaceCategories from "../modules/MarketPlace/Categories/index";
import MarketplaceUserDetails from "../modules/MarketPlace/MarketplaceUserDetails";
import BulkOfferList from "../modules/MarketPlace/BulkOffers/BulkOfferList";
import BulkOfferForm from "../modules/MarketPlace/BulkOffers/BulkOfferForm";
import ViewBulkOffer from "../modules/MarketPlace/BulkOffers/ViewBulkOffer";
import BulkOfferRequestList from "../modules/MarketPlace/BulkOfferRequests/BulkOfferRequestList";
import BookingList from "../modules/MarketPlace/Bookings/BookingList";
import ViewBooking from "../modules/MarketPlace/Bookings/ViewBooking";
import RequirementList from "../modules/MarketPlace/Requirements/RequirementList";
import AllCompanies from "../modules/Company/AllCompanies";
import Roles from "../modules/AdminManagement/Roles";
import AdminUsers from "../modules/AdminManagement/Users";
import BrokerProperties from "../modules/BrokerCRM/Properties";
import AddBrokerProperty from "../modules/BrokerCRM/Properties/AddBrokerProperty";
import PropertyDetail from "../modules/BrokerCRM/Properties/PropertyDetail";
import BrokerClients from "../modules/BrokerCRM/Clients";
import UserDetails from "../modules/Users/details/UserDetails";
import RequestDetail from "../modules/Company/verification-requests/RequestDetail";
import AllPublicProperties from "../modules/AllPublicProperties/AllPublicProperties";
import VerificationRequests from "../modules/Company/verification-requests";


const AppRoutes = () => (
  <AuthProvider>
    <LoaderProvider>
      <Loader />
      <Router>
        <Routes>

          <Route exact path={routes.login} element={<Login />} />
          <Route path={routes.home} element={<PrivateRouteLayout />}>
            <Route path={routes.home} element={<CommonLayout />}>
              <Route index element={<Navigate to={routes.userRPoint} replace />} />
              <Route exact path={routes.userRPoint} element={<AllUser />} />
              <Route exact path={routes.userMep} element={<AllUser />} />
              <Route exact path={"/test"} element={<UserDetails />} />

              <Route
                exact
                path={routes.userVerify}
                element={<RequestVerification />}
              />
              <Route exact path={routes.viewUser} element={<UserDetails />} />
              
              <Route path={routes.viewCompany} element={<CompanyDetails />} />
              
              <Route path={routes.addPortfolio} element={<PortfolioForm />} />
              <Route path={routes.viewPortfolio} element={<PortfolioForm />} />


              <Route exact path={routes.allCompanies} element={<AllCompanies />} />
              <Route exact path={routes.verificationRequests} element={<VerificationRequests />} />
              <Route path={routes.viewVerificationRequests} element={<RequestDetail />} />

              <Route
                exact
                path={routes.subscriptionPlans}
                element={<Plans />}
              />
              <Route
                exact
                path={routes.addSubscriptionPlan}
                element={<CreateEditPlan />}
              />
              <Route
                exact
                path={routes.editSubscriptionPlan}
                element={<CreateEditPlan />}
              />
              <Route
                exact
                path={routes.subscriptionFeatures}
                element={<Features />}
              />
              <Route
                exact
                path={routes.gisTrial}
                element={<GisTrial />}
              />
              {/* One screen per product; the key resets its state when switching. */}
              <Route
                exact
                path={routes.feedbackRpoint}
                element={<Feedback key="rpoint" product="rpoint" />}
              />
              <Route
                exact
                path={routes.feedbackMep}
                element={<Feedback key="mep" product="mep" />}
              />
              <Route
                exact
                path={routes.userSubscription}
                element={<Subscriptions />}
              />
              <Route
                exact
                path={routes.userSubscriptionDetails}
                element={<SubscriptionDetails />}
              />
              <Route
                exact
                path={routes.subscriptionPayments}
                element={<PaymentList />}
              />

              <Route exact path={routes.mapDynamic} element={<MapModule />} />
              <Route exact path={routes.mapGeoreference} element={<GeoreferenceWorkspace />} />
              <Route exact path={routes.mapGeoreferenceCreate} element={<GeoreferenceWorkspace />} />
              <Route exact path={routes.mapGeoreferenceList} element={<MapGeoreferenceModule />} />
              <Route exact path={routes.mapGeoreferenceImport} element={<ImportPackage />} />
              <Route exact path={routes.mapGeoreferenceImportDetail} element={<ImportPackage />} />


              <Route
                exact
                path={routes.jantriDynamic}
                element={<JantriModule />}
              />


              <Route exact path={routes.banner} element={<Banners />} />
              <Route exact path={routes.addBanner} element={<AddBanner />} />
              <Route exact path={routes.editBanner} element={<AddBanner />} />

              <Route exact path={routes.otpMessage} element={<OtpMessage />} />

              <Route
                exact
                path={routes.npaProperties}
                element={<NPAProperties />}
              />

              <Route exact path={routes.profile} element={<Profile />} />

              <Route
                exact
                path={routes.addNpaProperties}
                element={<AddNpaProperties />}
              />
              <Route
                exact
                path={routes.editNpaProperties}
                element={<AddNpaProperties />}
              />
              <Route
                exact
                path={routes.viewNpaProperties}
                element={<ViewNpaProperties />}
              />

              <Route
                exact
                path={routes.npaInquiries}
                element={<NPAInquiries />}
              />

              <Route exact path={routes.bankUsers} element={<BankUsers />} />


              <Route exact path={routes.banks} element={<Banks />} />
              <Route
                exact
                path={routes.viewBanksDetail}
                element={<ViewBankDetails />}
              />



              <Route exact path={routes.setting} element={<Setting />} />
              <Route exact path={routes.roles} element={<Roles />} />
              <Route exact path={routes.adminUsers} element={<AdminUsers />} />

              <Route exact path={routes.brokerProperties} element={<BrokerProperties />} />
              <Route exact path={routes.addBrokerProperty} element={<AddBrokerProperty />} />
              <Route exact path={routes.editBrokerProperty} element={<AddBrokerProperty />} />
              <Route exact path={routes.viewBrokerProperty} element={<PropertyDetail />} />
              <Route exact path={routes.brokerClients} element={<BrokerClients />} />
              <Route exact path={routes.publicProperties} element={<AllPublicProperties isLand={false} key="public-properties" />} />
              <Route exact path={routes.publicLands} element={<AllPublicProperties isLand={true} key="public-lands" />} />
              <Route exact path={routes.addPublicProperty} element={<AddBrokerProperty isLand={false} />} />
              <Route exact path={routes.editPublicProperty} element={<AddBrokerProperty isLand={false} />} />
              <Route exact path={routes.viewPublicProperty} element={<PropertyDetail />} />
              <Route exact path={routes.addPublicLand} element={<AddBrokerProperty isLand={true} />} />
              <Route exact path={routes.editPublicLand} element={<AddBrokerProperty isLand={true} />} />
              <Route exact path={routes.viewPublicLand} element={<PropertyDetail />} />

              <Route
                exact
                path={routes.marketplaceListings}
                element={<MarketplaceList />}
              />
              <Route
                exact
                path={routes.marketplaceCategories}
                element={<MarketplaceCategories />}
              />
              <Route
                exact
                path={routes.viewMarketplaceListing}
                element={<MarketplaceUserDetails />}
              />
              <Route
                exact
                path={routes.marketplaceBulkOffers}
                element={<BulkOfferList />}
              />
              <Route
                exact
                path={routes.createMarketplaceBulkOffer}
                element={<BulkOfferForm />}
              />
              <Route
                exact
                path={routes.editMarketplaceBulkOffer}
                element={<BulkOfferForm />}
              />
              <Route
                exact
                path={routes.viewMarketplaceBulkOffer}
                element={<ViewBulkOffer />}
              />
              <Route
                exact
                path={routes.marketplaceBulkOfferRequests}
                element={<BulkOfferRequestList />}
              />
              <Route
                exact
                path={routes.marketplaceBookings}
                element={<BookingList />}
              />
              <Route
                exact
                path={routes.viewMarketplaceBooking}
                element={<ViewBooking />}
              />
              <Route
                exact
                path={routes.marketplaceRequirements}
                element={<RequirementList />}
              />

              <Route
                exact
                path={routes.introductionScreens}
                element={<IntroductionScreens />}
              />
              <Route
                exact
                path={routes.addIntroductionScreen}
                element={<AddIntroductionScreen />}
              />
              <Route
                exact
                path={routes.editIntroductionScreen}
                element={<AddIntroductionScreen />}
              />

              <Route
                exact
                path={routes.profileSuggestionCards}
                element={<ProfileSuggestionCards />}
              />
            </Route>
          </Route>
        </Routes>
      </Router>

    </LoaderProvider>
  </AuthProvider>
);

export default AppRoutes;
